import React from 'react';

const Loading = ({ message = "Please wait while we fetch your locations." }) => {
  return (
    <div className="App">
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <h2>Loading...</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Loading;